(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('conges', {
            parent: 'technicienMenu',
            url: '/conges?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.conges.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/conges/conges.html',
                    controller: 'CongesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('conges');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('conges-detail', {
            parent: 'conges',
            url: '/conges/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.conges.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/conges/conges-detail.html',
                    controller: 'CongesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('conges');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Conges', function($stateParams, Conges) {
                    return Conges.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'conges',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('conges-detail.edit', {
            parent: 'conges-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/conges/conges-dialog.html',
                    controller: 'CongesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Conges', function(Conges) {
                            return Conges.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('conges.new', {
            parent: 'conges',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/conges/conges-dialog.html',
                    controller: 'CongesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                technicien: null,
                                date: null,
                                dateEnd: null,
                                paid: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('conges', null, { reload: 'conges' });
                }, function() {
                    $state.go('conges');
                });
            }]
        })
        .state('conges.edit', {
            parent: 'conges',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/conges/conges-dialog.html',
                    controller: 'CongesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Conges', function(Conges) {
                            return Conges.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('conges', null, { reload: 'conges' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('conges.delete', {
            parent: 'conges',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/conges/conges-delete-dialog.html',
                    controller: 'CongesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Conges', function(Conges) {
                            return Conges.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('conges', null, { reload: 'conges' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
